import {QueryFlexiPointsExpiryListArgs} from "@irati/types"

export const pointsExpiryVariables = (walletId: string, currency: string) => {
  const date = new Date()
  const now = date.toISOString()
  const ThirtyDaysFromNow = new Date(date.setDate(date.getDate() + 30)).toISOString()

  const variables: QueryFlexiPointsExpiryListArgs = {
    walletId,
    currency,
    fromDate: now,
    beforeDate: ThirtyDaysFromNow
  }
  return variables
}

export const daysLeft = (expiresAt: string) => {
  const expiryDate = new Date(expiresAt)
  const now = new Date()
  // Difference in milliseconds
  const diff = expiryDate.getTime() - now.getTime()
  // Convert the difference from milliseconds to days and return it
  return Math.ceil(diff / (1000 * 60 * 60 * 24))
}
